import { useContext } from 'react';
import CategoryPreview from '../../components/category-preview/category-preview.component';
import PageHeader from '../../components/page-header/page-header.component';
import { CategoriesContext } from '../../contexts/categories.context';
import '../../styles/product-grid.styles.scss';
import './categories-preview.styles.scss';

const CategoriesPreview = () => {
  const { categoriesMap } = useContext(CategoriesContext);

  return (
    <div className="shop-page">
      <PageHeader
        overline="Boutique"
        title="Nos produits"
        lead="Fleurs et résines sélectionnées directement chez les producteurs, testées en laboratoire et sous la barre des 0,3 % de THC."
      />

      {categoriesMap.map((category) => (
        <CategoryPreview
          key={category.title}
          title={category.title}
          products={category}
        />
      ))}
    </div>
  );
};

export default CategoriesPreview;
